import { useTheme } from "@mui/material";
import { ResponsiveFunnel } from "@nivo/funnel";
import { tokens } from "../theme";

const FunnelChart = ({ isDashboard = false, data }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  let funnelData = data;

  if (funnelData == null || funnelData == undefined || funnelData.length === 0)
  {
    funnelData = [
      { id: "", value: 0, label: "", color: "#ff5733" }
    ];
  
  }

  const formatCurrency = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `$${result}` : '';
  
      } else 
      {
        return "";
      }
  };

  const CustomTooltip = (data) => {

    if (!data) return null;
    
    let value = "";

    try
    {

      value = <div>{`${data.part.data.label}: ${formatCurrency(data.part.data.value)}`}</div>;

    }catch(error)
    {

    }
    return value;

  };

  return (
    <ResponsiveFunnel
      data={funnelData}
      margin={{ top: 20, right: 20, bottom: 50, left: 20 }}
      theme={{
        axis: {
          ticks: {
            text: {
              fill: colors.grey[100],
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[100],
          },
        },
      }}
      valueFormat={(value) => `${formatCurrency(value)}`}
      colors={{ datum: "color" }}
      borderColor={{ from: "color", modifiers: [["darker", 1.2]] }}
      labelColor={{ from: "color", modifiers: [["darker", 1.4]] }}
      enableBeforeSeparators={false}
      enableAfterSeparators={false}
      currentPartSizeExtension={10}
      currentBorderWidth={2}
      motionConfig="wobbly"
      role="application"
      ariaLabel="Nivo funnel chart example"
      layers={["separators", "parts", "labels", "legends"]}
      label={({ data }) => `${data.label}: ${formatCurrency(data.value)}`}
      tooltip={CustomTooltip}
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          translateY: 40,
          itemWidth: 100,
          itemHeight: 20,
          itemTextColor: colors.grey[100],
          symbolSize: 20,
          symbolShape: "circle",
        },
      ]}   




    />
  );
};

export default FunnelChart;
